import type { TabAmount, TabItem } from '@/types';
import { computed } from 'vue';
import { ENERGY_AND_WATER_DETAIL_ROUTE_NAME, WASTEWATER_DETAIL_ROUTE_NAME } from '../routes';
import { t } from '@/locales/i18n';

export const DEFAULT_TABS_AMOUNT: TabAmount[] = [
  {
    type: WASTEWATER_DETAIL_ROUTE_NAME,
    amount: 0
  },
  {
    type: ENERGY_AND_WATER_DETAIL_ROUTE_NAME,
    amount: 0
  }
];

export const manufacturingSelectionTabs = computed<TabItem[]>(() => [
  {
    id: 1,
    name: t('manufacturingSelection.continuousDyeing'),
    type: 'continuous-dyeing'
  },
  {
    id: 2,
    name: t('manufacturingSelection.exhaustDyeing'),
    type: 'exhaust-dyeing'
  },
  {
    id: 3,
    name: t('manufacturingSelection.laundry'),
    type: 'laundry'
  },
  {
    id: 4,
    name: t('manufacturingSelection.leather'),
    type: 'leather'
  },
  {
    id: 5,
    name: t('manufacturingSelection.overallPrinting'),
    type: 'overall-printing'
  },
  {
    id: 5,
    name: t('manufacturingSelection.positionalPrinting'),
    type: 'positional-printing'
  },
  {
    id: 6,
    name: t('manufacturingSelection.other'),
    type: 'other'
  }
]);

export const techAndMeasureTabs = computed<TabItem[]>(() => [
  {
    id: 1,
    name: t('techAndMeasures.categories.wastewater'),
    type: WASTEWATER_DETAIL_ROUTE_NAME
  },
  {
    id: 2,
    name: t('techAndMeasures.categories.energyAndWater'),
    type: ENERGY_AND_WATER_DETAIL_ROUTE_NAME
  }
]);
